module.exports = __webpack_public_path__ + "img/wood.8bb65a20.svg";